import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://qate.ai';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

const SEO = ({
  title = 'Qate AI - GenAI Quality Assurance | AI Testing for Web, Desktop & API',
  description = 'AI testing platform that clicks, types, and navigates your app like a real user. Conversational test creation, self-healing tests, automated bug fixing for web, Windows desktop & API.',
  canonical,
  ogImage = DEFAULT_OG_IMAGE,
  ogType = 'website',
  noindex = false,
  jsonLd
}) => {
  // Always produce a canonical URL — use explicit prop, or fall back to current path
  const path = canonical || (typeof window !== 'undefined' ? window.location.pathname : '/');
  const fullCanonical = path.startsWith('http') ? path : `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={fullCanonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:site_name" content="Qate AI" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(Array.isArray(jsonLd) ? jsonLd : [jsonLd])}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
